export default __webpack_public_path__ + "static/media/19.6ba8f208.jpg";